import axios from "axios";
import Swal from "sweetalert2";

const API_URL = "https://admin.uktechexam.co.in";

class AuthService {
  
  async logIp(){
    const response = await axios.get(`${API_URL}/api/v1/get-user-status`);
    return response.data;
  }
  async login(email, password) {
    console.log(email, password);

    try {
      const response = await axios.post(`${API_URL}/api/v1/login`, {
        email,
        password,
      });
      return response;
    } catch (error) {
      throw error;
    }
  }



  async logout() {
    const password = prompt("Enter logout password:");

    if (password === "321123") {
      localStorage.removeItem("token");


       Swal.fire({
        title: "Logout successful!",
        icon: "success",
        showConfirmButton: false,
      });
      localStorage.clear()

      setTimeout(()=>(
      window.location.reload()
      ),1000)

     
    } else {
      Swal.fire({
        title: "Incorrect password ?",
        icon: "error",
      });
    }
  }
}

export default  new AuthService();
